module.exports = __webpack_public_path__ + "assets/img/12.09f912db.png";